import { InjectionToken } from "@angular/core";
import { IndexedDbConfig } from "./indexed-db.config";

/**
 * `gciins-logs-db` — the logging subsystem's own IndexedDB database, deliberately **separate**
 * from `gciins-db` (see `indexed-db.config.ts` / the `INDEXED_DB_CONFIG` provider in
 * `app.config.ts`): keeping it out of `IndexedDbService`'s single-database model is what excludes
 * it from `PwaUpdateService.clearAllStores()`'s update-triggered wipe, with no allow-list or
 * special-case code needed anywhere.
 *
 * These constants are the single source of truth for its name/schema, imported by
 * `LogStoreWriter` and declared in `app.config.ts` through the `LOGS_DB_CONFIG` provider below.
 *
 * @see Docs/app-logs.md
 */
export const LOGS_DB_NAME = "gciins-logs-db";
// v2 adds `LOGS_TIMESTAMP_INDEX_NAME` so rotation can scan {id, timestamp} via a metadata-only
// key cursor instead of loading every full LogEntry — see `LogStoreWriter.fetchAllMeta()`.
export const LOGS_DB_VERSION = 2;
export const LOGS_STORE_NAME = "logs";
/** Non-unique index on `timestamp`, used by `LogStoreWriter.fetchAllMeta()` for rotation. */
export const LOGS_TIMESTAMP_INDEX_NAME = "timestamp_idx";

/**
 * Schema for `gciins-logs-db`, provided in `app.config.ts` next to `INDEXED_DB_CONFIG`.
 * It has its own token, so `IndexedDbService.clearAllStores()` never touches the logs.
 */
export const LOGS_DB_CONFIG = new InjectionToken<IndexedDbConfig>("LOGS_DB_CONFIG");
